<template>
  <div style="width: 100%;">
    <v-card outlined>
      <v-card-title>
        فیلتر <v-spacer></v-spacer>
        <v-btn fab dark small color="primary">
          <v-icon large @click="showSetting = !showSetting">
            {{ showSetting ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="showSetting">
        <v-row>
          <v-col cols="12" md="3" sm="6">
            <v-text-field
              dense
              label="نام کسب و کار"
              v-model="search.name"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" sm="6">
            <v-select
              :items="statusItem"
              label="وضعیت"
              dense
              clearable
              persistent-hint
              outlined
              v-model="search.statues"
              item-text="displayName"
              item-value="title"
            >
            </v-select>
          </v-col>
          <!-- <v-col cols="6" md="3">
            <date-picker
              v-model="search.CreatedFromDate"
              format="YYYY-MM-DD"
              display-format="jYYYY-jMM-jDD"
              ref="reserveDateUtc"
              required
              label="از تاریخ "
            />
          </v-col>
          <v-col cols="6" md="3">
            <date-picker
              v-model="search.CreatedToDate"
              format="YYYY-MM-DD"
              display-format="jYYYY-jMM-jDD"
              ref="reserveDateUtc"
              required
              label="تا تاریخ "
            />
          </v-col> -->
        </v-row>
      </v-card-text>
      <v-card-actions v-if="showSetting">
        <v-spacer></v-spacer>
        <v-btn color="error" @click="clearAll()">
          <span>حذف</span>
        </v-btn>
        <v-btn color="blue" dark @click="searchData()">
          <span>جست و جو</span>
          <v-icon small class="mx-1"> mdi-magnify </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { RepoFactory } from '@/baseRepository/Factory';
const enumsRepository = () => RepoFactory.get('enums');
import Helper from '@/core/helpers';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
export default {
  props: {
 
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      showSetting: false,
      search: {
        name: null,
        statues: null,
        // CreatedFromDate: null,
        // CretedToDate: null,
      },
      statusItem: [],
    };
  },
  mounted() {
    this.getMerchantsStatusEnum();
  },
  created() {
    //this.getMerchantsStatusEnum();
    // if (this.categoryType == 'Product') {
    //   if (this.$store.getters.ProductSearchFilterParams) {
    //     this.search = this.$store.getters.ProductSearchFilterParams;
    //     this.showSetting = true;
    //   }
    // } else if (this.categoryType == 'IndustrialService') {
    //   if (this.$store.getters.IndustrialServiceSearchFilterParams) {
    //     this.search = this.$store.getters.IndustrialServiceSearchFilterParams;
    //     this.showSetting = true;
    //   }
    // } else if (this.categoryType == 'ElectronicDocument') {
    //   if (this.$store.getters.ElectronicDocumentSearchFilterParams) {
    //     this.search = this.$store.getters.ElectronicDocumentSearchFilterParams;
    //     this.showSetting = true;
    //   }
    // } else if (this.categoryType == 'ConsultingService') {
    //   if (this.$store.getters.ConsultingServiceSearchFilterParams) {
    //     this.search = this.$store.getters.ConsultingServiceSearchFilterParams;
    //     this.showSetting = true;
    //   }
    // }
  },
  computed: {
    ...mapGetters(['merchantBaseUrl']),
  },
  methods: {
    clearAll() {
      this.search = {
        name: null,
        status: null,
        // CreatedFromDate: null,
        // CretedToDate: null,
      };
      this.searchData();
    },
    searchData() {
      this.$emit('searchParams', this.search);
    },
    getMerchantsStatusEnum() {
      enumsRepository()
        .getEnum('MerchantStatus', this.merchantBaseUrl)
        .then((res) => {
          this.statusItem = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
  },
};
</script>

<style>
</style>